import { Pipe, PipeTransform } from '@angular/core';
import { SampleState } from '../../../types/sample/SampleState';

@Pipe({
    name: 'sampleStateSeverity',
    standalone: true,
})
export class SampleStateSeverityPipe implements PipeTransform {
    transform(state: SampleState | undefined): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined {
        switch (state) {
            case SampleState.CREATED:
            case SampleState.PUBLISHED:
                return 'secondary';
            case SampleState.APPROVAL_REQUESTED:
            case SampleState.APPROVED_BY_REVIEWER:
                return 'contrast';
            case SampleState.IN_PRODUCTION:
                return 'success';
            case SampleState.ACTIVE:
                return 'success';
            case SampleState.ARCHIVED:
                return 'info';
            case SampleState.CHANGE_REQUESTED:
                return 'warn';
            default:
                return undefined;
        }
    }
}
